import React, { useEffect, useState } from "react";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { Form } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";

const ChangeEmailAddress = () => {
  const [newEmail, setNewEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const { t } = useTranslation();
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [errorToastMessage, setErrorToastMessage] = useState("");
  const language = localStorage.getItem("Lang"); 
  const [showErrorToast, setShowErrorToast] = useState(false);

  const handleChangeEmail = async () => {
    const sessionId = localStorage.getItem("sessionId");
    const token = localStorage.getItem("token");
    
      setLoading(true);


    
    if (!sessionId || !token) {
      setErrorToastMessage("Authentication error. Please log in again.");
      setShowErrorToast(true);
      setLoading(false);
      return;
    }
     if (!newEmail) {
      setWarningToastMessage("Please enter a new email address.");
      setShowWarningToast(true);
      setLoading(false);
      return;
    }

    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      newEmail: newEmail,
      password: password,
      langKey: language === "en" ? "" : language,
    };

    try {
      const response = await axios.post("/Account/ChangeEmailAddress", data);
      setToastMessage(response.data.message || "Email updated successfully.");
      setShowToast(true);
      setLoading(false);

      setNewEmail("");
      // setPassword("");
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      setLoading(false);

      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
        setLoading(false);

      }
    }
  };
  const [email, setEmail] = useState("");

  useEffect(() => {
  const storedEmail = localStorage.getItem("user-email");
  if (storedEmail) {
    setEmail(storedEmail);
  }
}, []);

// Clear any browser autofill that may populate the new email field
useEffect(() => {
  const t = setTimeout(() => setNewEmail(""), 50);
  return () => clearTimeout(t);
}, []);

  // -------------------------------------------------------------------------
  const { setIsNewsPageLoaded } = useNewsFeedStore();

  useEffect(() => {
    setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

    return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
  }, [setIsNewsPageLoaded]);

  // -------------------------------------------------------------------------

  

  return (
    <>
      <div className="setting-header">
        <h4>{t("User Profile.Change Email Address")}</h4>
      </div>
      <div className="p-2 privacy">
        <div className="mb-3">
           <Form autoComplete="off">
            {/* Hidden field to discourage browser autofill */}
            <input type="text" name="fakeusernameremembered" style={{ display: 'none' }} autoComplete="username" />
             <div className="row settings">
                <label className="mb-0 p-0 mb-1">{t("User Profile.Recent Email")}</label>
                <h6 className="p-0 f-600"> {email}</h6>

              <div className="col-12 mt-2 ps-0 mb-2 userInput">
                <label className="mb-0">{t("User Profile.New Email Address")}</label>
                <input
                  type="email"
                  className="form-control"
                  name="new-email-address-manual"
                  autoComplete="off"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  placeholder={t("Manage Companies.Enter Email Id")}
                />
              </div>
              <div className="col-12 ps-0 mb-3">
                <label className="mb-0">{t("SignIn.Password")}</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={t("SignIn.Password")}
                />
              </div>

              <div className="text-end">
                <button
                  type="button"
                  className="mainBtn1 mt-3 text-center"
                  onClick={handleChangeEmail}
                  disabled={loading}
                >
                  {loading ? `${t("User Profile.Updating")}` : `${t("User Profile.Update Email")}`}
                </button>
              </div>
            </div>
          </Form>
        </div>

        <SuccessToast
          show={showToast}
          message={toastMessage}
          onClose={() => setShowToast(false)}
        />
        <WarningToast
          show={showWarningToast}
          message={warningToastMessage}
          onClose={() => setShowWarningToast(false)}
        />
        <ErrorToast
          show={showErrorToast}
          message={errorToastMessage}
          onClose={() => setShowErrorToast(false)}
        />
      </div>
    </>
  );
};

export default ChangeEmailAddress;
